type Props = {
  layout: number;
};

const skeletonTextStyle: string = "mb-2.5 h-2 rounded-full bg-gray-700";

function BrandDetailsCardSkeleton({ layout }: Props) {
  return layout === 1 ? (
    <div className="mt-14 flex h-[450px] w-full animate-pulse items-center  justify-end rounded-2xl border-2 border-white border-opacity-20 bg-gray-700 pl-20 pr-14 ">
      <div className="relative h-[390px] w-[380px] rounded-2xl border-2 border-white border-opacity-30 bg-primary p-7 text-white ">
        <div className="mb-2 flex h-[100px] w-[100px] shrink-0 items-center justify-center rounded-lg border-2 border-white border-opacity-10 bg-gray-700">
          <svg
            className="h-12 w-12 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512"
          >
            <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg>
        </div>
        {/* <span className="w-full font-satoshi text-lg font-bold 2xl:text-[22px]"></span> */}
        <div className="mb-5 mt-3 h-5 rounded-full bg-gray-700" />
        <div>
          <div className={skeletonTextStyle} />
          <div className={skeletonTextStyle} />
          <div className={skeletonTextStyle} />
          <div className={skeletonTextStyle} />
          <div className={skeletonTextStyle} />
        </div>
        <div className="absolute bottom-5">
          <div className="mb-2.5 h-10 w-28 rounded-full bg-gray-700" />
        </div>
      </div>
    </div>
  ) : (
    <div className="discover-brand-card relative h-72 w-full animate-pulse  cursor-pointer 2xl:h-80">
      {
        <div className="flex h-60 w-full items-center justify-center rounded-2xl border-2 border-white border-opacity-10 bg-gray-700 2xl:h-64">
          {/* <svg className="w-12 h-12 text-gray-600" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg> */}
        </div>
      }
      <div
        className="absolute left-1/2 top-44 flex
            w-11/12 -translate-x-1/2 transform  space-x-2 rounded-2xl
            border-2 border-white border-opacity-20 bg-primary
           p-2 hover:z-10 2xl:p-4"
      >
        <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-ll border-2 border-white border-opacity-10 bg-gray-700 2xl:h-24 2xl:w-24">
          <svg
            className="h-12 w-12 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512"
          >
            <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg>
        </div>
        <div className="grow">
          <div className="mb-5 mt-3 h-5 rounded-full bg-gray-700" />
          <div className={skeletonTextStyle} />
          <div className={skeletonTextStyle} />
        </div>
      </div>
    </div>
  );
}
export default BrandDetailsCardSkeleton;
